const prediggoTranslation = {
  'productRange': 'rozsah',
  'productRange/BEAN_SAUCE': 'rozsah/bon-menu',
  'productRange/CORN': 'rozsah/zlata-kukurice',
  'productRange/LEGUMIO': 'rozsah/legumio',
  'productRange/MUSHROOMS': 'rozsah/zampiony',
  'productRange/OTHER_VEG': 'rozsah/ostatni',
  'productRange/PEAS': 'rozsah/hrasek',
  'productRange/SOUPS': 'rozsah/polevkove-smesi',
  'productRange/STEAM_CAN': 'rozsah/vapeur',
  'productRange/TOUCHE': 'rozsah/mini',
  'productRange/CREATIF': 'rozsah/creatif',
  'productRange/READY_FROZ': 'rozsah/hotova-jidla',
  'cultureType': 'typ-plodiny',
  'cultureType/Bio': 'typ-plodiny/bio',
  'cultureType/Sans%20r%E9sidu%20de%20pesticide': 'typ-plodiny/bez-pesiticdu',
  'cultureType/Sans%20OGM': 'typ-plodiny/bez-gmo',
};

export default prediggoTranslation;
